import React from 'react';
import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { Button } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, TextField, Box } from '@mui/material';

const BROWSER_INFO = (() => {
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown';
  let fullVersion = 'Unknown';

  if (userAgent.indexOf('Chrome') > -1) {
    browserName = 'Chrome';
    fullVersion = userAgent.substring(userAgent.indexOf('Chrome') + 7);
    fullVersion = fullVersion.substring(0, fullVersion.indexOf(' '));
  } else if (userAgent.indexOf('Firefox') > -1) {
    browserName = 'Firefox';
    fullVersion = userAgent.substring(userAgent.indexOf('Firefox') + 8);
  } else if (userAgent.indexOf('Safari') > -1) {
    browserName = 'Safari';
    fullVersion = userAgent.substring(userAgent.indexOf('Version') + 8);
    fullVersion = fullVersion.substring(0, fullVersion.indexOf(' '));
  } else if (userAgent.indexOf('Edge') > -1) {
    browserName = 'Edge';
    fullVersion = userAgent.substring(userAgent.indexOf('Edge') + 5);
  }

  return `name: ${browserName}, full_version: ${fullVersion}, userAgent: ${userAgent}`;
})();

const sendSupportEmailMutation = gql`
  mutation sendSupportEmailMutation($url: String!, $description: String, $browser: String, $resolution: String, $file_data: String) {
    sendSupportEmail(url: $url, description: $description, browser: $browser, resolution: $resolution, file_data: $file_data) {
      response
    }
  }
`;

function SupportModal({ onCancel, screenShotFileData }) {
  const [submitted, setSubmitted] = React.useState(false);
  const [responseOk, setResponseOk] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  
  const [sendSupportEmail] = useMutation(sendSupportEmailMutation);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    setLoading(true);

    const form_elements = event.target.elements;
    sendSupportEmail({
      variables: {
        url: window.location.href,
        description: form_elements.description.value,
        browser: BROWSER_INFO,
        resolution: `${window.innerWidth} x ${window.innerHeight}`,
        file_data: screenShotFileData
      },
    }).then(({ data: { sendSupportEmail } }) => {
      setLoading(false);
      if (sendSupportEmail.response === 'ok') {
        setResponseOk(true);
        setTimeout(() => {
          onCancel();
        }, 2000);
      }
    }).catch((error) => {
      setLoading(false);
      setSubmitted(false);
      setError(true);
    });
  };

  return (
    <Dialog open={true} maxWidth="md" fullWidth>
      <DialogTitle>Send message to weldinGo Support</DialogTitle>
      <DialogContent>
        {loading && (
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            flexDirection: 'column'
          }}>
            <Box sx={{ 
              width: 40, 
              height: 40, 
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginBottom: 2
            }} />
            <Box sx={{ color: '#666', fontSize: '16px' }}>Sending...</Box>
          </Box>
        )}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
        {responseOk ? (
          <Box sx={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#4dbd74'
          }}>
            <Box sx={{ fontSize: '60px', marginBottom: '20px' }}>✓</Box>
            <h4 style={{ color: '#4dbd74', marginBottom: '15px' }}>Thank you!</h4>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Thank you for submitting the report. Our operators will contact you immediately.
            </p>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              required
              multiline
              rows={10}
              name="description"
              label="Issue Description"
              fullWidth
              margin="normal"
            />
            {error && (
              <Box sx={{ color: 'error.main', mt: 2 }}>
                <p>Failed to send the form. Please contact us via email at support@weldingo.com</p>
              </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
              <Button variant="outlined" color="error" onClick={onCancel} disabled={loading}>
                Cancel
              </Button>
              {!submitted && !error && (
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                  {loading ? 'Sending...' : 'Send'}
                </Button>
              )}
              {error && (
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                  Retry
                </Button>
              )}
            </Box>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default SupportModal;